import React, { PropTypes } from 'react';

import Modal from 'components/UI/Modal'
import Button from 'react-bootstrap/lib/Button'
import { confirmable } from 'react-confirm';
import classnames from 'classnames';
import "./alert.scss";

const DEFAULT_ALERT_WIDTH = 352;

class Alert extends React.Component {
  render() {
    const {
			okButtonTitle,
			title,
      text,
      show,
      proceed,
      dismiss,
			cancel,
			alertType,
      enableEscape = true,
		} = this.props;

		return (
			<Modal
				isShowingModal={show} // if you want to show it when component mounts, set it true
				className={classnames("alert-modal", "classtop-alert-" + alertType)}
				fixedWidth={this._getAlertWidth()}
				allowCloseByClickingShadow={true}
				// contentHeight={300}

				hasHeader={true}
				headerType="bold" // default, bold
				headerTitle={this._renderAlertTitle()}

				hasFooter={true}
				footerType="bold" // grey, transparent, bold
				footerButtons={[
					{
						title: okButtonTitle || __("Confirm", "UI.alert"), 
						className: "btn btn-primary pull-right",
						onClick: proceed
					},
				]}
			>
				<div className='alert-content'>
					<div className='alert-text'>
						{text}
					</div>
				</div>
			</Modal>
    )
	}

		_renderAlertTitle() {
			const {
				title,
				alertType,
			} = this.props;

			let icon;

			switch(alertType) {
				case "message":
					break;
				case "warning":
					icon = <div className='alert-icon'><i className='fa icon-attention-alt'></i></div>
					break;
				case "success":
					icon = <div className='alert-icon'><i className='fa icon-ok'></i></div>
					break;
				case "fail":
					icon = <div className='alert-icon'><i className='fa icon-cancel'></i></div>
					break;
				case "error":
					icon = <div className='alert-icon'><i className='fa icon-attention-alt'></i></div>
					break;
			}


			return (<div>
				{icon}
				<div>{title}</div>
			</div>);
		}

		_getAlertWidth() {
			let {
				alertType,
				fixedWidth,
			} = this.props;

			let width;

			switch(alertType) {
				case "message":
					width = 450;
					break;
			}

			return fixedWidth || width || DEFAULT_ALERT_WIDTH;
		}

}

Alert.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  show: PropTypes.bool,
  proceed: PropTypes.func,     // called when ok button is clicked.
  cancel: PropTypes.func,      // called when cancel button is clicked.
  dismiss: PropTypes.func,     // called when backdrop is clicked or escaped.
  enableEscape: PropTypes.bool,
}

export default confirmable(Alert);



// WEBPACK FOOTER //
// ./src/components/UI/Alert/index.js